import { useCallback } from 'react';
import { useRecoilState, useResetRecoilState } from 'recoil';
/**
 * Hook to be used instead of useRecoilState to make sure undefined values get converted to null.
 * This makes sure that fields from MUI are never uncontrolled.
 *
 * @param atom Recoil atom or selector
 */
export function useMuiFieldRecoilState(atom) {
    const [state, setState] = useRecoilState(atom);
    const resetState = useResetRecoilState(atom);
    const setOrResetState = useCallback((valOrUpdater) => {
        if (typeof valOrUpdater === 'function') {
            // cannot return null from an updater function
            return setState(valOrUpdater);
        }
        if (valOrUpdater === null)
            return resetState();
        return setState(valOrUpdater);
    }, [resetState, setState]);
    return [state ?? null, setOrResetState];
}
